<template>
    <div>
        <div class="title_text">
            <div>
                <Icon type="ios-bookmark" size="18" color="#0466dd" />
                <span class="title_text2">入职告知书</span>
            </div>
        </div>
        <div class="project_contract_div">

            <div class="button_div">
                <div class="hint_txt">
                </div>
                <Button type="primary" size="small" style="font-size: 13px" @click="add_show = true">
                    <Icon type="md-add" />添加
                </Button>
            </div>
            <div>
                <Table size="small" :columns="columns" :data="table_data">
                    <template #file="{ row }">
                        <span class="download_span" @click="view_file(row)">
                            <Icon type="ios-cloud-download-outline" />{{ row.file }}
                        </span>
                    </template>
                    <template #del_file="{ row }">
                        <span class="del_file" @click="del_file(row)">
                            删除
                        </span>
                    </template>

                </Table>
            </div>
        </div>

        <Modal v-model="add_show" title="添加入职告知书" :footer-hide="true">
            <div>
                <Alert type="warning" style="font-size: 13px">PDF文件如过大请先压缩，<a target='_blank'
                        href="/tools/compress/pdf">点击去压缩PDF</a></Alert>
            </div>
            <div>

                <div class="add_contract_field">
                    <div class="add_title">告知书文件：</div>
                    <div>
                        <Upload :action="upload_url" :on-success="upload_success" ref="upload">
                            <Button icon="ios-cloud-upload-outline">点击上传文件</Button>
                        </Upload>
                    </div>
                </div>

                <div class="add_contract_button_div">
                    <Button @click="add_gaozhishu()" style="font-size: 12px" type="primary">
                        <Icon type="md-add" />确认添加
                    </Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";

export default {
    name: "gaozhishu",

    data() {
        return {
            project_id: "",
            add_show: false,
            upload_url:
                process.env.VUE_APP_HOST +
                "/project_manage/create/upload_gaozhishu?token=" +
                this.$cookies.get("dx_token"),
            upload_file_url: "",
            columns: [],
            table_data: []

        }
    },
    mounted() {

    },
    methods: {
        view_file(item) {
            get_view_file_url(item.file)
        },

        open(project_id) {
            this.project_id = project_id
            this.get_gaozhishu()
            console.log('请求告知书')
        },

        fast_open(project_id) {
            this.project_id = project_id
            this.add_show=true
        },

        get_gaozhishu() {
            var that = this;
            var body = {
                project_id: this.project_id,
            };

            http(
                "post",
                process.env.VUE_APP_HOST +
                "/project_manage/create/gaozhishu_list",
                body,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.table_data = res.data.table_data;
                        that.columns = res.data.columns
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });

        },



        add_gaozhishu() {
            var that = this;
            var body = {
                project_id: this.project_id,
                object_name: this.upload_file_url
            };

            http(
                "post",
                process.env.VUE_APP_HOST +
                "/project_manage/create/add_gaozhishu",
                body,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_gaozhishu()
                        that.add_show = false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        del_file(item) {
            console.log(item)
            var that = this;
            var body = {
                project_id: this.project_id,
                gzs_id: item.id
            };

            http(
                "post",
                process.env.VUE_APP_HOST +
                "/project_manage/create/del_gaozhishu",
                body,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_gaozhishu()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        upload_success(e) {
            console.log(e);
            if (e.code != 0) {
                this.$Message.error(e.msg);
                this.$refs.upload.clearFiles();
                this.upload_file_url = "";
            } else {
                this.$Message.success(e.msg);
                this.upload_file_url = e.data.url;
            }
        },
    }
}
</script>

<style scoped>
.del_file {
    color: red;
    cursor: pointer;
}

.download_span {
    color: #0466dd;
    cursor: pointer;
}

.project_contract_div {
    margin-top: 10px;
    margin-bottom: 15px;
    padding: 0 10px
}

.title_text2 {
    font-weight: 600;
}

.title_text {
    margin: 0px 10px 0 10px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #ddd;
    padding: 10px 10px 5px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    letter-spacing: 2px;
}

.del {
    color: rgb(210, 58, 58);
    cursor: pointer;
    margin-left: 10px;
}

.pdf_icon {
    width: 70px;
    height: 70px;
    opacity: 0.2;
    position: absolute;
    right: 10px;
    top: 20px;
}

.is_long_time {
    display: flex;
    align-items: flex-end;
}

.add_contract_date {
    display: flex;
}

.iconyiguoqi1 {
    color: red;
    font-size: 50px;
    position: absolute;
    right: 20px;
}

.view_contract {
    color: #0466dd;
    cursor: pointer;
}

.card_list {
    height: calc(100vh - 130px);
    overflow: auto;
    padding: 10px 0;
}

.card_span {
    color: #4b4b4b;
    font-weight: 600;
}

.contract_card {
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    box-shadow: 0 0 3px #f7f7f7;
    color: #a8a8a8;
    padding: 10px;
    font-size: 13px;
    margin-bottom: 10px;
    position: relative;
}

.add_contract_button_div {
    margin-top: 40px;
    display: flex;
    justify-content: flex-end;
}

.add_title {
    width: 100px;
    flex-shrink: 0;
}

.add_contract_field {
    display: flex;
    align-items: center;
}

.hint_txt {
    padding-left: 10px;
    color: #939393;
    font-size: 13px;
    ;
}


.button_div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* position: absolute; */
    bottom: 10px;
    margin-bottom: 5px;
    /* background: red; */
}
</style>